import axios from "axios";
import authHeader from "../../services/auth-header";
import ConstApiUrls from "../../services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL;

class FKegiatanMaterialService {
  getApiUrl() {
    return API_URL;
  }
  getAllFKegiatanMaterial() {
    return axios.get(API_URL + `getAllFKegiatanMaterial`, {
      headers: authHeader(),
    });
  }
  getAllFKegiatanMaterialContaining(page, pageSize, sortBy, order, search) {
    // return axios.get(API_URL + `getAllFKegiatanMaterial`, { headers: authHeaderMultipart() });
    return axios.get(
      API_URL +
        `getAllFKegiatanMaterialContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getFKegiatanMaterialById(id) {
    return axios.get(API_URL + `getFKegiatanMaterialById/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFKegiatanMaterialByParent(id) {
    return axios.get(API_URL + `getAllFKegiatanMaterialByParent/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFKegiatanMaterialByParentIds(ids) {
    return axios.get(API_URL + `getAllFKegiatanMaterialByParentIds/${ids}`, {
      headers: authHeader(),
    });
  }

  updateFKegiatanMaterial(item) {
    return axios.put(API_URL + `updateFKegiatanMaterial/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFKegiatanMaterial(item) {
    return axios.post(API_URL + `createFKegiatanMaterial`, item, {
      headers: authHeader(),
    });
  }
  deleteFKegiatanMaterial(id) {
    return axios.delete(API_URL + `deleteFKegiatanMaterial/${id}`, {
      headers: authHeader(),
    });
  }

  deleteFKegiatanMaterialAvatarByParent(fkegiatanBean) {
    return axios.delete(
      API_URL + `deleteFKegiatanMaterialAvatarByParent/${fkegiatanBean}`,
      {
        headers: authHeader(),
      }
    );
  }
  createFKegiatanMaterialAvatar(item) {
    return axios.post(API_URL + `createFKegiatanMaterialAvatar`, item, {
      headers: authHeader(),
    });
  }

  deleteAllFKegiatanMaterial(itemIds) {
    return axios.delete(API_URL + `deleteAllFKegiatanMaterial`, {
      headers: authHeader(),
      data: itemIds,
    });
  }
}
export default new FKegiatanMaterialService();
